import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import * as propTypes from 'prop-types';
import VirtualList, { ItemStyle } from 'react-tiny-virtual-list';
import { ALIGNMENT } from 'react-tiny-virtual-list/types/constants';
import { FormSelectChoice } from '../../../../lib/types/types';

interface InputSelectListProps {
    getItemProps: any;
    getMenuProps: any;
    highlightedIndex: number;
    itemToString: any;
    options: FormSelectChoice[];
}

const ROW_HEIGHT = 42;
const AUTO_SCROLL = 'auto' as ALIGNMENT.AUTO;

const InputSelectList = ({ getItemProps, getMenuProps, highlightedIndex, options, itemToString }: InputSelectListProps) => {
    const fullHeight = options.length * ROW_HEIGHT;
    const itemCount = options.length;

    const item = (index: number, style: ItemStyle) => {
        return (
            <div
                className={`sid-input-select-list__item ${highlightedIndex === index ? 'sid-input-select-list__item--highlighted' : ''}`}
                key={options[index].value}
                {...getItemProps({
                    style,
                    index,
                    item: options[index],
                })}
                >
                {itemToString(options[index])}
            </div>
        );
    };

    return(
        <VirtualList
            {...getMenuProps()}
            className={'sid-input-select-list__menu'}
            height={Math.min(fullHeight, 280)}
            itemCount={itemCount}
            itemSize={ROW_HEIGHT}
            renderItem={({ index, style }) => item(index, { ...style, width: 'auto' })}
            scrollToAlignment={AUTO_SCROLL}
            scrollToIndex={highlightedIndex || 0}
            width={'100%'}
        />
    );
};

InputSelectList.propTypes = {
    getItemProps: propTypes.func.isRequired,
    getMenuProps: propTypes.func.isRequired,
    itemToString: propTypes.func.isRequired,
    highlightedIndex: propTypes.number.isRequired,
    options: propTypes.array.isRequired,
};

export const InputSelectListComponent = InputSelectList;
